import { usePageCharts } from '~/api/hooks/useCharts'
import {
  useReviewPageState,
  useComparisonState,
  ReviewPageScaffold,
  PageTiles,
} from '~/components/ReviewPage'
import { PAGE_DEFAULTS } from '~/components/ReviewPage/pageDefaults'

export function MultiDeepDive() {
  const state = useReviewPageState({
    pageId: 'MultiDeepDive',
    factTable: 'model_tracking',
    defaultKpi: PAGE_DEFAULTS.MultiDeepDive,
    archetype: 'performance',
    multiTimeframe: true,
  })
  const compare = useComparisonState(state.fromIso, state.toIso)
  const charts = usePageCharts(state.pageId, state.kpi)
  return (
    <ReviewPageScaffold
      title="Multi Deep Dive"
      state={state}
      compare={compare}
      showComparison={false}
      showGranularity={false}
    >
      <PageTiles charts={charts} state={state} compare={compare} pageSlug="multideepdive" />
    </ReviewPageScaffold>
  )
}
